<div class="v2-disclaimer">
  @if (themeService.isFinnet()) {
    <p>
      Die Analysen werden von der <strong>finanzen.net GmbH</strong> erstellt und bereitgestellt.
      Für bestimmte Daten und Inhalte arbeitet die finanzen.net GmbH mit externen Datenanbietern
      zusammen:
    </p>
    <ul>
      <li>
        <strong>Quartr:</strong> Bereitstellung von Earnings-Berichten und
        Unternehmensveröffentlichungen als Grundlage für die Earnings-Analyse
      </li>
      <li><strong>FactSet:</strong> Bereitstellung von Kennzahlen zu EPS, Umsatz und Gewinn</li>
      <li>
        <strong>TipRanks:</strong> Bereitstellung von Analystenbewertungen, Kurszielen und
        Konsens-Ratings
      </li>
    </ul>
    <p>
      Die Analyse stellt
      <strong>keine Anlageberatung, Anlageempfehlung oder Anlagestrategieempfehlung</strong> im
      Sinne des KWG, WpIG oder WpHG dar und berücksichtigt nicht Deine persönliche finanzielle
      Situation, Risikobereitschaft oder steuerliche Lage. Die Inhalte dienen ausschließlich
      Informationszwecken.
    </p>
    <p>
      <a routerLink="/terms" queryParamsHandling="preserve">Nutzungsbedingungen</a>
    </p>
  } @else {
    <p>
      Mit Aufruf der AI-Analysen haben Sie die Anwendung der finanzen.net zero GmbH verlassen. Die
      AI-Analysen werden von der finanzen.net GmbH bereitgestellt und auf deren Plattform angezeigt;
      es gelten deren Nutzungs- und Datenschutzbestimmungen.
    </p>
    <p>
      Die Anzeige der AI-Analysen begründet keine inhaltliche Verantwortlichkeit der finanzen.net
      zero GmbH. Die Verantwortung für die Erstellung und Bereitstellung der AI-Analysen liegt
      ausschließlich bei der finanzen.net GmbH als Datenanbieter.
    </p>
    <p>
      Weitere Informationen zu den AI-Analysen können auf der
      <strong>Website der finanzen.net</strong> GmbH eingesehen werden.
    </p>
  }
</div>
